import React from "react";
import Condizioni_it from "./condizioni/Condizioni_it";
import Privacy_it from "./privacy-docs/Privacy_it";
import Privacy_en from "./privacy-docs/Privacy_en";
import Condizioni_en from "./condizioni/Condizioni_en";

interface IProps {
    doc: string;
    lang: string;
}

export default class DocPage extends React.Component<IProps>{

    private getComponent(): React.ReactNode {
        if (this.props.doc === 'c') return this.getCondizioni();
        else if (this.props.doc === 'p') return this.getPrivacy();
        return <></>;
    }

    private getPrivacy(): React.ReactNode {
        switch (this.props.lang) {
            case 'it': return <Privacy_it />;
            default: return <Privacy_en />;
        }
    }

    private getCondizioni(): React.ReactNode {
        switch (this.props.lang) {
            case 'it': return <Condizioni_it />;
            default: return <Condizioni_en />;
        }
    }

    render(): React.ReactNode {
        return <div className={'DocPage'}>{this.getComponent()}</div>;
    }

}